import React, { useEffect, useState } from 'react';
import { endpoints } from 'endpoints.config';
import { InfoTable } from 'components/infoTable/infoTable';
import WarningIcon from '../../../images/Icon_Warning.png';

type Props = {
  currentSynOpt: string;
};

export const PreviouslyMatchedRecords: React.FC<Props> = ({ currentSynOpt }) => {
  const [listUrl, setListUrl] = useState<string>("");
  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(true);
  const [tableError, setTableError] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>(null);
  const [toggleRecordsShow, setToggleRecordsShow] = useState<boolean>(false);
  
  useEffect(() => {
    if(currentSynOpt){
      loadData();
    }
  }, [currentSynOpt]);

  const loadData = async () => {
    const currentListUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.prevMatchedRecordsClass :
      endpoints.wondeIntegration.prevMatchedRecordsPupil;

    setListUrl(currentListUrl);
  };  

  return (
    <>
      <div className="Btn BtnOrange RightBtn" onClick={() => setToggleRecordsShow(!toggleRecordsShow)}>{toggleRecordsShow ? "Hide" : "Show"} Previously Matched Records</div>

      <div className="PrevMatchedRecords" style={{ display: toggleRecordsShow ? "block" : "none" }}>
        <h2>Previously Matched Records</h2>

        {listUrl && !tableError && 
          <InfoTable
            listUrl={listUrl}
            firstColWidth={215}
            firstColWidthSm={110}
            updateListStatus={true}
            setIsPanelClosed={setIsPanelClosed}
            isPanelClosed={isPanelClosed}
            allowSelectAll={false}
            filterTable={false}
            hideSideMenu={true}
            rowHighlight={false}
            hideChkboxCol={true}
            setTableData={setTableData}
            setTableError={setTableError}
          >
          </InfoTable>
        }

        {tableData && tableData.length <= 0 &&
          <p>You have no matched Wonde - Get Set records.</p>
        }

        {tableError &&
          <div className="ListTableMsgContainer">
            <div className="Msg">
              <div className="MsgContainer">
                <div className="Img"><img src={WarningIcon} alt="Warning" /></div>
                <div className="Txt">An error occurred loading previously matched records.</div>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );  
};